import React, { useState } from 'react';
import { Activity, CalendarRange, Package, Repeat } from 'lucide-react';
import { PillTabBar } from '../../../reusable';
import BudgetCostStructurePanel from './BudgetCostStructurePanel';
import BudgetProductCostPanel from './BudgetProductCostPanel';
import BudgetPunctualCostPanel from './BudgetPunctualCostPanel';
import BudgetVariableCostPanel from './BudgetVariableCostPanel';

const COST_TABS = [
  { key: 'product', label: 'Costo producto', icon: Package },
  { key: 'recurring', label: 'Recurrentes', icon: Repeat },
  { key: 'punctual', label: 'Puntuales', icon: CalendarRange },
  { key: 'variable', label: 'Variables', icon: Activity },
];

const BudgetCostsSection = (props) => {
  const [costTab, setCostTab] = useState('recurring');

  return (
    <div>
      <PillTabBar
        ariaLabel="Tipos de costo"
        items={COST_TABS}
        activeKey={costTab}
        onChange={setCostTab}
        style={{ marginBottom: 12 }}
      />
      {costTab === 'product' ? <BudgetProductCostPanel {...props} /> : null}
      {costTab === 'recurring' ? <BudgetCostStructurePanel {...props} /> : null}
      {costTab === 'punctual' ? <BudgetPunctualCostPanel {...props} /> : null}
      {costTab === 'variable' ? <BudgetVariableCostPanel {...props} /> : null}
    </div>
  );
};

export default BudgetCostsSection;
